import React, { useState, Component, Fragment } from 'react';
import { PropTypes } from 'prop-types';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import EwaybillEnable from './EwaybillEnable';
import EwaybillLogin from './EwayBillLogin';
import './style.scss';
import EwaybillList from '../EwaybillList';

const EwaybillAuth = ({ user }) => {
  const [login, setLogin] = useState(false);
  return (
    <div
      className=" "
      // style={{ paddingTop: '85px' }}
    >
      {
        !user.user_tenants.find((tenant) => tenant.tenant_id === user.tenant_info.tenant_id)?.is_e_way_bill_enabled && !login && <EwaybillEnable user={user} updateLogin={(value) => setLogin(value)} />
      }
      {
        login && <EwaybillLogin user={user} />
      }
      {
              user.user_tenants.find((tenant) => tenant.tenant_id === user.tenant_info.tenant_id)?.is_e_way_bill_enabled && <EwaybillList user={user} />
      }
    </div>
  );
};

// export default EwaybillAuth;
const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
});

const mapDispatchToProps = () => ({
});

EwaybillAuth.propTypes = {
  user: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EwaybillAuth));
